const crouselDataAirbus = [
    {
        "id": 1,
        "imgPath": "/assets/images/Home/crousel/img-1.png"
    },
    {
        "id": 2,
        "imgPath": "/assets/images/Home/crousel/img-2.png"
    },
    {
        "id": 3,
        "imgPath": "/assets/images/Home/crousel/img-3.png"
    },
    {
        "id": 4,
        "imgPath": "/assets/images/Home/crousel/img-4.png"
    },
    {
        "id": 5,
        "imgPath": "/assets/images/Home/crousel/img-5.png"
    },
    {
        "id": 6,
        "imgPath": "/assets/images/Home/crousel/img-6.png"
    },
    {
        "id": 7,
        "imgPath": "/assets/images/Home/crousel/img-7.png"
    },
    {
        "id": 8,
        "imgPath": "/assets/images/Home/crousel/img-8.png"
    },
    {
        "id": 9,
        "imgPath": "/assets/images/Home/crousel/img-9.png"
    },

]

const crouselDataSafran = [
    {
        "id": 1,
        "imgPath": "/assets/safran/home/safranHome1.png"
    },
    {
        "id": 2,
        "imgPath": "/assets/safran/home/safranHome2.png"
    },
    {
        "id": 3,
        "imgPath": "/assets/safran/home/safranHome3.png"
    },
    {
        "id": 4,
        "imgPath": "/assets/safran/home/safranHome4.png"
    },
    {
        "id": 5,
        "imgPath": "/assets/safran/home/safranHome5.png"
    },
    {
        "id": 6,
        "imgPath": "/assets/safran/home/safranHome6.png"
    },
    {
        "id": 7,
        "imgPath": "/assets/safran/home/safranHome7.png"
    },
    {
        "id": 8,
        "imgPath": "/assets/safran/home/safranHome8.png"
    },
    // {
    //     "id": 9,
    //     "imgPath": "/assets/safran/home/safranHome9.png"
    // },

]
export {
    crouselDataAirbus, crouselDataSafran
}